// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sources-view__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--color-border-light);
  gap: 0.25rem;
}
.sources-view__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text-primary);
}
.sources-view__title .material-icons {
  font-size: 18px;
  color: var(--color-primary);
}
.sources-view__count {
  font-size: 0.75rem;
  color: var(--color-text-secondary);
  background: var(--color-background-light);
  border-radius: 12px;
  border: 1px solid var(--color-border-light);
}
.sources-view__grid {
  display: grid !important;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  grid-template-columns: 1fr;
}
.sources-view__grid::before, .sources-view__grid::after {
  content: "";
  display: none;
}
@media screen and (min-width: 768px) {
  .sources-view__grid {
    grid-template-columns: repeat(auto-fit, minmax(48%, 1fr));
  }
}
@media screen and (min-width: 1200px) {
  .sources-view__grid {
    grid-template-columns: repeat(auto-fit, minmax(33%, 1fr));
    gap: 0.25rem;
  }
}
@media screen and (min-width: 1440px) {
  .sources-view__grid {
    grid-template-columns: repeat(auto-fit, minmax(23%, 1fr));
    gap: 0.25rem;
  }
}
@media screen and (max-width: 768px) {
  .sources-view {
    margin: 0.75rem 0;
  }
  .sources-view__header {
    margin-bottom: 0.5rem;
  }
  .sources-view__title {
    font-size: 0.9rem;
  }
  .sources-view__count {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/SourcesView/SourcesView.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kDAAA;EACA,YAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAFJ;AAII;EACE,eAAA;EACA,2BAAA;AAFN;AAME;EACE,kBAAA;EACA,kCAAA;EACA,yCAAA;EACA,mBAAA;EACA,2CAAA;AAJJ;AAOE;EACE,wBAAA;EACA,gBAAA;EAAA,WAAA;EACA,0BAAA;AALJ;AAOI;EACE,WAAA;EACA,aAAA;AALN;AAQI;EAVF;IAWI,yDAAA;EALJ;AACF;AAOI;EAdF;IAeI,yDAAA;IACA,YAAA;EAJJ;AACF;AAMI;EAnBF;IAoBI,yDAAA;IACA,YAAA;EAHJ;AACF;AAOE;EA5DF;IA6DI,iBAAA;EAJF;EAME;IACE,qBAAA;EAJJ;EAOE;IACE,iBAAA;EALJ;EAQE;IACE,iBAAA;IACA,sBAAA;EANJ;AACF","sourcesContent":[".sources-view {\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid var(--color-border-light);\n    gap: 0.25rem;\n  }\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--color-text-primary);\n\n    .material-icons {\n      font-size: 18px;\n      color: var(--color-primary);\n    }\n  }\n\n  &__count {\n    font-size: 0.75rem;\n    color: var(--color-text-secondary);\n    background: var(--color-background-light);\n    border-radius: 12px;\n    border: 1px solid var(--color-border-light);\n  }\n\n  &__grid {\n    display: grid !important;\n    gap: 0.5rem;\n    grid-template-columns: 1fr;\n\n    &::before, &::after {\n      content: \"\";\n      display: none;\n    }\n\n    @media screen and (min-width: 768px) {\n      grid-template-columns: repeat(auto-fit, minmax(48%, 1fr));\n    }\n\n    @media screen and (min-width: 1200px) {\n      grid-template-columns: repeat(auto-fit, minmax(33%, 1fr));\n      gap: 0.25rem;\n    }\n\n    @media screen and (min-width: 1440px) {\n      grid-template-columns: repeat(auto-fit, minmax(23%, 1fr));\n      gap: 0.25rem;\n    }\n  }\n\n  // Responsive adjustments\n  @media screen and (max-width: 768px) {\n    margin: 0.75rem 0;\n\n    &__header {\n      margin-bottom: 0.5rem;\n    }\n\n    &__title {\n      font-size: 0.9rem;\n    }\n\n    &__count {\n      font-size: 0.7rem;\n      padding: 0.2rem 0.4rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
